import { useDispatch, useSelector } from "react-redux";
import CustomModel from "../../../../components/custom-model/CustomModel";
import { selectApheresis } from "../../../slices/qualityApproval";
import { notify } from "../../../utils/methods/notification";
import * as Yup from "yup";
import { selectCurrentCycle } from "../../../slices/common";

const PublishProductModel = ({ publishModalOpen, setPublishModalOpen, data, getTimeLine }) => {
    const dispatch = useDispatch()
    const currentCycle = useSelector(selectCurrentCycle)

    const modelData = {
        title: "Publish Product",
        children: [
            {
                type: 'date',
                name: 'manufacturedDate',
                label: "Manufactured Date ",
               // disabled: true,
            },
            {
                type: 'description',
                name: 'comment',
                label: "Comments",
                placeholder: 'Enter Comment',
                IsRequired: true,
            }
        ]
    }

    const modalInitialValues = {
        comment: "",
        manufacturedDate: data.mfg_date
    }

    const validationSchema = Yup.object().shape({
        comment: Yup.string().required("Comment is required").min(2, "Comment must be at least 2 characters").max(500, "Comment must be at most 500 characters"),
    });

    const handlePublish = async (values) => {
        if (!data) return;
        try {
            const payload = {
                product_id: data?.product_id,
                patient_id: data?.patient_information?.id,
                feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
                product_manufacturing_id: currentCycle?.product_manufacturing_id,
                qr_code_generated_id: data?.qrCode_id,
                comment: values.comment,
            };
            await dispatch(selectApheresis(payload)).unwrap();
            notify.success("Product published successfully!");
            await getTimeLine()
            setPublishModalOpen(false);
        } catch (error) {
            console.error("Error selecting apheresis:", error);
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Failed to publish product. Please try again.";
            notify.error(errorMessage);
            setPublishModalOpen(false);
        }
    };

    return (<CustomModel
        modelData={modelData}
        open={publishModalOpen}
        setOpen={setPublishModalOpen}
        modalInitialValues={modalInitialValues}
        initialValuesValidationSchema={validationSchema}
        handleModelValues={handlePublish}
    />)
}
export default PublishProductModel;